import { PollApi } from '@calm/evexia-web-sdk/generated/lib/api/poll-api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `MediaApi`
 * @param accessToken
 * @returns
 */
export default function createPollApi(accessToken: () => Promise<string>) {
    return createApi(PollApi, accessToken);
}
